import { render } from "./HeroiconsSolidBriefcase.vue?vue&type=template&id=b0f6f61c"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBriefcase.vue"]])

export default __exports__